import { safePost, safeGet, safePut, safeDelete, groupsHostUrl } from './http'
import { IMediaTypeGroup } from '../types/mediaTypeGroup'
import { IMediaType } from '../types/mediaType'

const mediaTypeGroupUrl = `${groupsHostUrl}/media-type-groups`

export const createMediaTypeGroup = (mediaTypeGroupData: IMediaTypeGroup) =>
  safePost(mediaTypeGroupUrl, mediaTypeGroupData)

export const getMediaTypeGroups = () => safeGet(mediaTypeGroupUrl)

export const getMediaTypeById = (id: string) =>
  safeGet(`${mediaTypeGroupUrl}/${id}`)

export const deleteMediaTypeGroup = (id: string) =>
  safeDelete(`${mediaTypeGroupUrl}/${id}`)

export const updateMediaTypeGroup = (mediaTypeGroupData: IMediaTypeGroup) =>
  safePut(`${mediaTypeGroupUrl}/${mediaTypeGroupData.id}`, mediaTypeGroupData)

// Formik escapes "." in field name
export const tranfsormMediaTypesForFormik = (
  { types }: IMediaTypeGroup,
  list: IMediaType[]
): {
  [x: string]: boolean
} =>
  list.reduce(
    ($, item) => ({
      ...$,
      [item.extension.replace('.', '')]: !!types.find(
        ({ extension }) => extension === item.extension
      ),
    }),
    {}
  )

export const transformFormDataToSend = (
  values,
  list: IMediaType[]
): Array<{ extension: string }> =>
  list
    .filter(({ extension }) => values[extension.replace('.', '')])
    .map(({ extension }) => ({ extension }))
